import entryFactory from '../../entry'
import router from './router'
import store from './store'

entryFactory(store, router)



// WEBPACK FOOTER //
// ./app/resource/page/index/index.js